module.exports = __webpack_public_path__ + "static/media/bread-loaf.8f27c1b4.svg";